import { render, staticRenderFns } from "./rotationset.vue?vue&type=template&id=3979219a&scoped=true&"
import script from "./rotationset.vue?vue&type=script&lang=js&"
export * from "./rotationset.vue?vue&type=script&lang=js&"
import style0 from "./rotationset.vue?vue&type=style&index=0&id=3979219a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979219a",
  null
  
)

export default component.exports